import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Components
import Header from './Header';

import group from '../../../static/img/group.png';

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop:"20px",
        marginBottom: "35px",
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        boxShadow: '0 6px 10px 0 rgba(0, 0, 0, 0.1)',
        margin: 'auto',
        height: 'auto',
        textAlign: 'center',
        width: '40em'
    },
    tituloFooter: {
        color: '#999999'
    }
});

class Congrats extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { classes } = this.props;
        console.dir(classes)
        return (
            <div className="congrats">
                <div className="congrats-container">
                    <Header />
                    <Grid
                        alignContent="center"
                        container
                        className={classes.root}>
                        <Paper className={classes.paper}>
                            <div className="icono">
                                <img src={group} />
                            </div>
                            <Typography
                                variant="h4">
                                ¡Listo! Solo te falta autorizar la transferencia en tu otro banco
                            </Typography>
                            <br/>
                            <Typography
                                variant="title">
                                Buscá la opción "<strong>colocación a plazo</strong>"
                                en tu cuenta del {this.props.banco} y autorizala
                            </Typography>
                            <Typography
                                variant="title">
                                ¡Lo podés hacer de manera <strong>online</strong>!
                            </Typography>
                            <br />
                            <Typography
                                variant="subheading"
                                className={classes.tituloFooter}>
                                si tenés alguna duda podés contactarte con tu banco para que te guíe como hacerlo.
                            </Typography>
                            <br />
                        </Paper>
                    </Grid>
                </div>
            </div>
        );
    }
}

Congrats.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = function (state) {
    console.log(state)
    return {
        banco: state.plazoFijoConfirmacion.banco
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles))
    (Congrats);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/congrats/Congrats.js